<template>
  <v-container fluid>
    <v-row dense>
      <v-col cols="12">
        <v-toolbar class="elevation-2">
          <v-row dense>
            <v-col cols="12" sm="6" md="4">
              <SelectedGroupDinamicField :itemAction="selectedPeriodos" :on-success="actionFieldData" />
            </v-col>
          </v-row>
          <v-spacer></v-spacer>
        </v-toolbar>
        <DataTableMain :datatable="table" :on-success="successAction" :itemsAction="tableAction"/>
      </v-col>
      <v-col cols="12">
        <ViewDetails :object="object" type="NominaEmpleadosDetail" :itemsAction="tableAction"/>
      </v-col>
    </v-row>
      <NominaMainDialog v-if="get_dialogMain.dialog" :model="nomina" :params="paramsDialog" :on-success="dataForm" :view="view"/>
  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import XLSX from 'xlsx'
import DataTableMain from '@/components/tables/DataTableMain'
import NominaMainDialog from '@/components/dialogs/nomina/NominaMainDialog'
import SelectedGroupDinamicField from '@/components/fields/SelectedGroupDinamicField'
import ViewDetails from '@/components/ViewDetails'
import { Permission } from '@/mixins/permissionMain'
export default {
  mixins: [Permission],
  data: () => ({
    table: {
      modelMain: [],
      showSelect: true,
      singleSelect: true,
      header: {
        options: [
          { title: 'Refrescar', icon: 'mdi-cached', color: 'primary', action: 'refreshData', code: 'libre', hidden: '' },
          { title: 'Nuevo', icon: 'mdi-plus', color: 'success', action: 'newData', code: 'nomina.execute.create-create' },
          { title: 'Nominas Gral.', icon: 'mdi-clipboard-list', color: 'info', action: 'ExportNominasGenral', code: 'nomina.export.nominas-general' }
        ],
        titles: [
          { text: 'Folio', value: 'folio', class: 'black--text' },
          { text: 'Nombre', value: 'NombreCompleto', class: 'black--text' },
          { text: 'Periodo', value: 'periodo.descripcion', class: 'black--text' },
          { text: 'Total Percepciones', value: 'FieldDinamicDataSimple', class: 'black--text', action: 'FormatNumberMoney', field: 'total_percepciones' },
          { text: 'Total Deducciones', value: 'FieldDinamicDataSimple', class: 'black--text', action: 'FormatNumberMoney', field: 'total_otras_deducciones' },
          { text: 'Total Bruto', value: 'FieldDinamicDataSimple', class: 'black--text', action: 'FormatNumberMoney', field: 'Bruto' },
          { text: 'Total ISPT', value: 'FieldDinamicDataSimple', class: 'black--text', action: 'FormatNumberMoney', field: 'total_impuestos_retenidos' },
          { text: 'Total Subsidio', value: 'FieldDinamicDataSimple', class: 'black--text', action: 'FormatNumberMoney', field: 'total_otros_pagos' },
          { text: 'Total Neto', value: 'FieldDinamicDataSimple', class: 'black--text', action: 'FormatNumberMoney', field: 'Neto' },
          { text: 'Activo', value: 'Activo', class: 'black--text' },
          { text: 'Estatus', value: 'Status', class: 'black--text' },
          { text: '', value: 'Actions', class: 'black--text' }
        ],
        loading: false
      },
      body: {
        data: [],
        actions: [
          { title: 'Reporte Nomina', icon: 'mdi-file-excel-box', color: 'yellow darken-3', action: 'ExportTodos', code: 'libre', hidden: '' },
          { title: 'Reporte Presupuestal', icon: 'mdi-file-excel-box', color: 'yellow darken-3', action: 'ExportPresupuestal', code: 'libre', hidden: '' },
          { title: 'Recibos Nomina', icon: 'mdi-file-pdf-box', color: 'yellow darken-3', action: 'ExportRecibos', code: 'libre', hidden: '' },
          { title: 'Dispersiones Nomina', icon: 'mdi-zip-box', color: 'yellow darken-3', action: 'ExportDispersion', code: 'libre', hidden: '' },
          { title: 'Timbrado', icon: 'mdi-file-document-multiple', color: 'yellow darken-3', action: 'ExportTimbandoDispersion', code: 'libre', hidden: '' }
        ]
      },
      footer: {
        paging: true
      }
    },
    selectedPeriodos: {
      field: 'selectGroupDataServer',
      name: 'Periodos',
      nameid: 'ejercicio_id',
      url: '/nomina/config/ejercicio/periodos',
      rules: true,
      default: true,
      cols: 12
    },
    params: {},
    nomina: {},
    view: null,
    paramsDialog: {},
    concepto: ''
  }),
  components: {
    DataTableMain,
    NominaMainDialog,
    SelectedGroupDinamicField,
    ViewDetails
  },
  mounted () {
    // this.getUrl('POST/nomina/show')
    this.ShowPermisos({ permisos: JSON.parse(localStorage.getItem('permisos')), tableMain: this.table })
  },
  methods: {
    ...mapActions(['getUrlServices', 'postServiceListAction', 'getServicesActionParams', 'postUrlExportDataServerAction', 'getUrExporPdftDataServerAction', 'getUrExportZipDataServerAction', 'getUrExportDataServerAction']),
    dataForm ({ name, model }) {
      if (name === 'exportExcel') {
        const url = this.get_urls['POST/nomina/reportes/nominas-generales']
        this.postUrlExportDataServerAction({ url: url, nombre: 'nominas_generales', data: model })
      }
    },
    // *==========*==========*==========*==========* \\
    getUrl (objet) {
      if (this.get_urls != null) {
        const router = this.get_urls[objet]
        this.postServiceListAction({ url: router, data: this.params })
      } else {
        this.getUrlServices()
      }
    },
    successAction (item) {
      this[item.action](item)
    },
    refreshData (item) {
      this.table.header.loading = true
      this.getUrl('POST/nomina/show')
    },
    newData (item) {
      this.view = null
      this.nomina = {
        tipo_nomina: 'Ordinaria',
        generar_complementos: 'NO',
        generar_a_todas_area_trabajo: 'SI',
        generar_a_todos: 'SI'
      }
      this.SHOW_DIALOG_MAIN({ type: 'create', with: 900, title: 'Generar Nomina', body: { setModel: true } })
    },
    ExportNominasGenral (item) {
      this.nomina = {}
      this.paramsDialog = { returnObjet: true, form: this.get_exporByDatestForm }
      this.SHOW_DIALOG_MAIN({ type: 'exportExcel', form: 'gral', with: 500, title: 'Reporte de Nominas' })
    },

    tableAction (item) {
      // console.log(item)
      this[item.action](item)
    },
    toLoadFouls (item) {
      this.view = null
      this.nomina = item
      this.SHOW_DIALOG_MAIN({ type: 'messageConfirm', with: 850, title: 'ASISTENCIAS' })
    },
    toTemplateCreate (item) {
      this.view = null
      this.nomina = item
      this.SHOW_DIALOG_MAIN({ type: 'createPlantilla', with: 500, title: 'Generar Pre-Plantilla' })
    },
    toLoadCredits (item) {
      this.view = null
      this.nomina = item
      this.SHOW_DIALOG_MAIN({ type: 'loadCredits', with: 500, title: 'CARGAR CREDITOS' })
    },
    toLoadConcept (item) {
      this.view = null
      this.nomina = item
      this.SHOW_DIALOG_MAIN({ type: 'loadConceptsAdditional', with: 500, title: 'CARGAR CONCEPTOS ADICIONALES' })
      // this.SHOW_DIALOG_MAIN({ type: 'loadConceptsAdditional', form: 'importData', with: 1100, title: 'CARGAR CONCEPTOS ADICIONALES' })
    },
    toProcessNomina (item) {
      this.view = null
      this.nomina = item
      this.SHOW_DIALOG_MAIN({ type: 'processNomina', with: 500, title: 'PROCESAR NOMINA GENERADA' })
    },
    toCloseNomina (item) {
      this.view = null
      this.nomina = item
      this.SHOW_DIALOG_MAIN({ type: 'CloseNomina', with: 500, title: 'CERRAR NOMINA' })
    },

    ExportTodos (item) {
      const url = this.get_urls['GET/nomina/reporte/{nomina_id}']
      this.getServicesActionParams({ url: url, params: `/${item.item.id}`, replace: '/{nomina_id}' })
    },
    ExportPresupuestal (item) {
      const url = this.get_urls['GET/nomina/reportes/presupuestal-contable/{nomina_id}']
      this.getUrExportDataServerAction({ url: url, params: `/${item.item.id}`, replace: '/{nomina_id}', nombre: item.item.NombreCompleto })
    },
    ExportDispersion (item) {
      if (item.item.Neto <= 0) {
        this.$swal({
          type: 'error',
          icon: 'error',
          title: 'Advertencia!',
          text: 'La Nomina  ' + item.item.NombreCompleto + ' debe estar procesada!!'
        })
        return
      }
      this.$swal.fire({
        title: 'Agregar concepto para dispersión:',
        input: 'text',
        inputAttributes: {
          maxlength: 20
        },
        text: item.item.NombreCompleto,
        inputValue: item.item.NombreCompleto.substring(0, 20),
        showCloseButton: true,
        confirmButtonText: 'Descargar',
        showLoaderOnConfirm: true,
        inputValidator: (value) => {
          return new Promise((resolve) => {
            if (value.length <= 20 && this.checkIfStringHasSpecialChar(value)) {
              resolve()
            } else {
              resolve('Maximo 20 caracteres y no debe tener espacios caracteres especiales.')
            }
          })
        },
        allowOutsideClick: () => !this.$swal.isLoading()
      }).then((result) => {
        if (result.isConfirmed) {
          const url = this.get_urls['GET/nomina/dispersiones/hsbc/{nomina_id}/{concepto}[/{adscripcion_id}]']
          this.getUrExportZipDataServerAction({ url: url, params: `/${item.item.id}/${result.value.trim()}`, replace: '/{nomina_id}/{concepto}[/{adscripcion_id}]', nombre: item.item.NombreCompleto })
        }
      })
    },
    ExportTimbandoDispersion ({ item }) {
      const url = this.get_urls['GET/nominas/timbrado/{padre_id}']
      this.getUrExportDataServerAction({ url: url, params: `/${item.id}`, replace: '/{padre_id}', nombre: item.NombreCompleto })
    },
    checkIfStringHasSpecialChar (value) {
      const spChars = /[`!@#$%^&*()_+\-=\\[\]{};':"\\|,.<>\\/?~]/
      if (spChars.test(value)) {
        return false
      } else {
        return true
      }
    },
    ExportRecibos (item) {
      const url = this.get_urls['GET/nomina/reportes/recibos/{nomina_id}[/{adscripcion_id}]']
      this.getUrExporPdftDataServerAction({ url: url, params: `/${item.item.id}`, replace: '/{nomina_id}[/{adscripcion_id}]', nombre: item.item.NombreCompleto })
    },
    // methods details
    nominaDetailEmployee ({ item }) {
      this.view = item
      this.SHOW_DIALOG_MAIN({ type: 'viewDetilConcepts', with: 750, title: `${item.adscripcion.empleado.cve_empleado} - ${item.adscripcion.empleado.NombreCompleto}`, form: 'NominaDetalleConceptos' })
    },
    actionFieldData (obj) {
      this.table.header.loading = true
      this.params = {}
      if (obj.data) {
        this.params.ejercicio_id = obj.data
      }
      this.getUrl('POST/nomina/show')
      // this.getUrl('POST/asistencia/incidencias/show')
    },
    ...mapMutations(['SHOW_DIALOG_MAIN', 'CLEAR_DATA_LIST'])
  },
  computed: {
    ...mapGetters(['get_dialogMain', 'get_urls', 'get_objects', 'get_export', 'get_exporByDatestForm']),
    object () {
      if (this.table.modelMain.length > 0) {
        return this.table.modelMain[0]
      }
      return {}
    }
  },
  watch: {
    get_urls () {
      this.getUrl('POST/nomina/show')
    },
    get_objects (vals) {
      if (vals) {
        this.table.header.loading = false
        this.table.modelMain = []

        if (vals.length > 0) {
          this.table.modelMain.push(vals[0])
        }
        this.table.body.data = vals
      }
    },
    get_export (vals) {
      if (vals) {
        const data = XLSX.utils.json_to_sheet(vals.data)
        const workbook = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(workbook, data, 'Page_1')
        XLSX.writeFile(workbook, `${vals.nombre}.xlsx`)
      }
    }
  },
  beforeDestroy () {
    this.CLEAR_DATA_LIST()
  }
}
</script>

<style>

</style>
